import React from 'react';
import { ACCOUNT_TYPE_STUDENT } from 'constants/types';
import AccountAccessDenied from './AccountAccessDenied';

const AccountStudentAccessDenied = ({ children }) => {
  return (
    <AccountAccessDenied
      title="Sua conta de estudante não permite o acesso à esse recurso."
      types={[ACCOUNT_TYPE_STUDENT]}
    >
      {children}
    </AccountAccessDenied>
  );
};

export default AccountStudentAccessDenied;
